import {AlertTypeDTO, Completable, pending} from 'kashable-mobile-common';

import {getNotifications} from '../apis/monitoring';
import {AlertSelectOption} from '../hooks/useAlerts';
import {RootState} from '../store';

import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AlertParams {
    length?: number;
    offset?: number;
    type?: AlertSelectOption;
}

const INITIAL_STATE: Completable<AlertTypeDTO[]> = pending();

export const fetchAlerts = createAsyncThunk(
    'alerts/fetch',
    async ({length = 10, offset = 0, type = AlertSelectOption.ALL}: AlertParams, {rejectWithValue}) => {
        const response = await getNotifications(length, offset, type);

        if (response.error) {
            rejectWithValue(response);
        }

        return response;
    },
);

export const alertsSlice = createSlice({
    name: 'alerts',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        updateAlerts: (state, action: PayloadAction<AlertTypeDTO[]>) => {
            const value = state.value ? [...state.value] : [];
            const newState = {
                ...state,
                value: value.map((item) => {
                    const currentAlert = action.payload.find(({gid}) => gid === item.gid);

                    if (currentAlert) {
                        return currentAlert;
                    }
                    return item;
                }),
            };
            return {...newState};
        },
        clearAlerts: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlerts.pending, () => {
                return pending();
            })
            .addCase(fetchAlerts.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const selectAlerts = (state: RootState) => state.alerts;
export const {
    updateAlerts,
    clearAlerts,
} = alertsSlice.actions;
export default alertsSlice.reducer;
